import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import TextField from 'material-ui/TextField';

const TextFormGroup = ({ input, placeholder, type, maxLength, disabled,
  readOnly, autoComplete, className, inputClassName,
  id, autoFocus, meta: { touched, error } }) => {
  const materialInputProps = {
    fullWidth: true,
    floatingLabelText: placeholder,
    errorText: touched && error,
  };
  const inputElement = (
    <TextField
      {...input}
      {...materialInputProps}
      id={id}
      maxLength={maxLength}
      autoComplete={autoComplete}
      disabled={disabled}
      readOnly={readOnly}
      type={type}
      className={inputClassName}
      autoFocus={autoFocus}
      name={id}
    />
  );

  return (
    <div className={cn({ 'has-error': touched && error }, className)}>
      { inputElement }
    </div>
  );
};

TextFormGroup.propTypes = {
  input: PropTypes.object.isRequired,
  // label: PropTypes.string,
  autoComplete: PropTypes.string,
  maxLength: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  id: PropTypes.string,
  meta: PropTypes.object,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
    PropTypes.object,
  ]),
  inputClassName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  autoFocus: PropTypes.bool,
};

TextFormGroup.defaultProps = {
};

export default TextFormGroup;



// WEBPACK FOOTER //
// ./src/components/Forms/TextFormGroup.js